var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarningCircleRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-597 -386)",
    fill: "#e73439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(597 386)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.529 390.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon--white",
    d: "M334.731,240.037a1,1,0,0,1-1-1v-6a1,1,0,1,1,2,0v6A1,1,0,0,1,334.731,240.037Z",
    transform: "translate(-333.729 -232.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon--white",
    d: "M334.729,243.04a1.038,1.038,0,0,1-.709-.3.972.972,0,0,1-.21-.32,1,1,0,0,1-.081-.38,1.034,1.034,0,0,1,.291-.71,1.046,1.046,0,0,1,1.419,0,1.028,1.028,0,0,1,.29.71.977.977,0,0,1-.08.38.956.956,0,0,1-.21.32A1,1,0,0,1,334.729,243.04Z",
    transform: "translate(-333.729 -232.037)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningCircleRed);
export default __webpack_public_path__ + "static/media/icon-warning-circle-red.848ad006.svg";
export { ForwardRef as ReactComponent };